import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import _ from 'lodash';
import { useMemo } from 'react';

import { getFriendlyId } from '@/utils/friendlyId';

import { conformanceRatingFromResults } from '../calculateConformanceRating';
import { latestResultValueFromData } from '../latestResultValueFromData';
import type { IndicatorFlatFields, IndicatorTableFields } from './types';

export const useLabelledFields = (
  records: IndicatorFlatFields[] | undefined
) => {
  const { getLabel: getConformanceLabel } = useRating(
    'indicator_conformance_status'
  );
  const { getLabel: getTestFreqLabel } = useRating('frequency');

  return useMemo<IndicatorTableFields[] | undefined>(() => {
    return records?.map((d) => {
      return {
        ...d,
        LatestResultValue: latestResultValueFromData(d) || '-',
        LatestResultDate: d.orderedResults[0]?.ResultDate || '-',
        Conformance: conformanceRatingFromResults(d),
        ConformanceLabelled: getConformanceLabel(
          conformanceRatingFromResults(d)
        ),
        TestFrequencyLabelled: getTestFreqLabel(d.schedule?.Frequency) || '-',
        SequentialIdLabel: d.SequentialId
          ? getFriendlyId(Parent_Type_Enum.Indicator, d.SequentialId)
          : '',
      };
    });
  }, [records, getConformanceLabel, getTestFreqLabel]);
};
